import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import React from "react";
import {withErrorBoundary} from "../../../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../../../boundaries/GeneralErrorBoundary";


const HitachiMap = {
    'HITACHI_DEVICE': {
        serialNumber: true,
        exportToolPath: true,
    },
    'HITACHI_UPLOAD': {
        serialNumber: true,
        exportToolPath: true,
    },
    'TEST_HITACHI_DEVICE': {
        serialNumber: true,
        exportToolPath: true,
    },
    'HITACHI_HNAS_DEVICE': {},
    'HITACHI_OPS_DEVICE': {
        apiToken: true,
        port: true,
        serialNumber: true,
        hitachiDeviceOption: true,
        secondaryIpAndPort: true
    },
}


const HitachiInputs = ({
                           device,
                           cli_path,
                           port,
                           api_token,
                           handleInputChange,
                           lgColSize
                       }) => {

    const exportToolPathBox = () => {
        return (
            <Col lg={lgColSize} sm={6}>
                <FormGroup>
                    <Label htmlFor="cli_path">Export Tool Path</Label>
                    <Input required type="text" name="cli_path" value={cli_path} onChange={handleInputChange}/>
                </FormGroup>
            </Col>
        )
    }

    const portBox = () => {
        return (
            <Col lg={lgColSize} sm={6}>
                <FormGroup>
                    <Label htmlFor="port">Port</Label>
                    <Input required type="text" name="port" value={port} onChange={handleInputChange}/>
                </FormGroup>
            </Col>
        )
    }

    const apiTokenBox = () => {
        return (
            <Col lg={lgColSize} sm={6}>
                <FormGroup>
                    <Label htmlFor="apiToken">Api Token</Label>
                    <Input required type="text" name="api_token" value={api_token} onChange={handleInputChange}/>
                </FormGroup>
            </Col>
        )
    }

    const serialNumberBox = () => {
        return (
            <Col sm={6} xs={12}>
                <Label htmlFor="serial_number">Serial Number</Label>
                <Input required type="text" name="serial_number"
                       value={device?.serial_number}
                       onChange={handleInputChange}/>
            </Col>
        )
    }

    const secondaryIpBox = () => {
        return (
            <Row>
                <Col sm={6} xs={12}>
                    <Label htmlFor="secondary_ip">Secondary IP</Label>
                    <Input required type="text" name="secondary_ip"
                        value={device?.secondary_ip}
                        onChange={handleInputChange}/>
                </Col>
                <Col sm={6} xs={12}>
                    <Label htmlFor="secondary_port">Secondary Port</Label>
                    <Input required type="number" name="secondary_port"
                        value={device?.secondary_port}
                        onChange={handleInputChange}/>
                </Col>
            </Row>
        )
    }

    const filterHitachiDevices = () => {
        if (device?.device_type_code?.includes?.('HITACHI')) {
            return (
                <>
                    {HitachiMap?.[device?.device_type_code]?.port ? portBox() : null}
                    {HitachiMap?.[device?.device_type_code]?.apiToken ? apiTokenBox() : null}
                    {HitachiMap?.[device?.device_type_code]?.serialNumber ? serialNumberBox() : null}
                    {HitachiMap?.[device?.device_type_code]?.exportToolPath ? exportToolPathBox() : null}
                    {HitachiMap?.[device?.device_type_code]?.secondaryIpAndPort ? secondaryIpBox() : null}
                </>
            )
        } else {
            return null
        }
    }
    return filterHitachiDevices();
}

export default withErrorBoundary(HitachiInputs, GeneralErrorBoundary);